module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageServiceProvider.svg?afea1370";